import { Card, Col, Row, Statistic } from 'antd';
import type { BdoSummaryResponse } from '../types';
import { formatMg } from '../types';

interface Props {
    summary?: BdoSummaryResponse;
    loading?: boolean;
    isMobile?: boolean;
}

export default function BdoSummaryCards({ summary, loading, isMobile }: Props) {
    const cards = summary?.cards;
    const showMultimaterial = (cards?.multimaterialMg || 0) > 0;

    return (
        <Row gutter={[12, 12]}>
            <Col xs={12} md={showMultimaterial ? 6 : 8}>
                <Card size="small" loading={loading}>
                    <Statistic
                        title="Opakowania produktów"
                        value={formatMg(cards?.productsMg)}
                        suffix="Mg"
                        valueStyle={{ fontSize: isMobile ? 18 : 22 }}
                    />
                </Card>
            </Col>
            <Col xs={12} md={showMultimaterial ? 6 : 8}>
                <Card size="small" loading={loading}>
                    <Statistic
                        title="Opakowania zbiorcze"
                        value={formatMg(cards?.collectiveMg)}
                        suffix="Mg"
                        valueStyle={{ fontSize: isMobile ? 18 : 22 }}
                    />
                </Card>
            </Col>
            <Col xs={12} md={showMultimaterial ? 6 : 8}>
                <Card size="small" loading={loading}>
                    <Statistic
                        title="Razem 1A"
                        value={formatMg(cards?.total1AMg)}
                        suffix="Mg"
                        valueStyle={{
                            fontSize: isMobile ? 18 : 22,
                            color: '#1677ff',
                            fontWeight: 600,
                        }}
                    />
                </Card>
            </Col>
            {showMultimaterial && (
                <Col xs={12} md={6}>
                    <Card size="small" loading={loading}>
                        <Statistic
                            title="Wielomateriałowe 5.2"
                            value={formatMg(cards?.multimaterialMg)}
                            suffix="Mg"
                            valueStyle={{
                                fontSize: isMobile ? 18 : 22,
                                color: '#fa8c16',
                            }}
                        />
                    </Card>
                </Col>
            )}
        </Row>
    );
}
